import { useCareplanContext } from "@/domains/careplan/contexts/use-careplan-context";
import { CareplanCartSubscriptionStatus } from "@/routes/_private/-components/cart/careplan-cart-subscription-status";

export const InactiveSubscriptionCard = () => {
  const { subscription } = useCareplanContext();

  if (!subscription) {
    return null;
  }

  return (
    <CareplanCartSubscriptionStatus.Root
      className="flex flex-col gap-3"
      subscription={subscription}
    >
      <CareplanCartSubscriptionStatus.Title level={4}>
        {`You don't have any active subscriptions`}
      </CareplanCartSubscriptionStatus.Title>
      <CareplanCartSubscriptionStatus.Description>
        Reactivate by checking out below
      </CareplanCartSubscriptionStatus.Description>
    </CareplanCartSubscriptionStatus.Root>
  );
};
